import { useLocalStorageState } from 'ahooks'
import dayjs from 'dayjs'

import { trackEmitter } from '../helpers/trackEmitter'

import { useSessionInfo } from '@/contexts/AuthContext/hooks/sessionInfo'


import { useEffect } from 'react';
export function useTrackSessionStart() {
  const { sessionLoading } = useSessionInfo()

  const [trackSessionStart, setTrackSessionStart] = useLocalStorageState(
    'track-session-start',
    {
      defaultValue: {
        date: '',
      },
      listenStorageChange: true,
    },
  )

  useEffect(() => {
    if (sessionLoading) {
      return
    }
    const today = dayjs().format('YYYY-MM-DD')
    const lastTrackDate = trackSessionStart?.date
    // 如果今天还没有上报过，或者没有记录，则上报
    if (lastTrackDate !== today) {
      trackEmitter.emit('track-event', {
        name: 'session_start',
      })
      // 更新最后上报日期
      setTrackSessionStart({
        date: today,
      })
    }
  }, [sessionLoading, trackSessionStart?.date, setTrackSessionStart])
}
